
<svg
  aria-hidden="true"
  class="my-24 mx-16 fill-brand"
  width="30"
  height="30"
  viewBox="0 0 30 30"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 0H7V2H23V0H25V2H28C29.1046 2 30 2.89543 30 4V28C30 29.1046 29.1046 30 28 30H2C0.89543 30 0 29.1046 0 28V4C0 2.89543 0.89543 2 2 2H5V0ZM25 4H23H7H5H2V6H28V4H25ZM2 28V8H28V28H2ZM15 10C10.5817 10 7 13.5817 7 18C7 22.4183 10.5817 26 15 26C19.4183 26 23 22.4183 23 18C23 13.5817 19.4183 10 15 10ZM15 12C18.3137 12 21 14.6863 21 18C21 21.3137 18.3137 24 15 24C11.6863 24 9 21.3137 9 18C9 14.6863 11.6863 12 15 12ZM15 13.0625C15.5128 13.0625 15.9355 13.4485 15.9933 13.9459L16 14.0625V17.2167L18.6992 17.9399C19.2327 18.0829 19.5492 18.6312 19.4063 19.1647C19.2736 19.66 18.7913 19.9684 18.2959 19.8955L18.1816 19.8718L14.8008 18.9659C14.3247 18.8384 14.0213 18.3879 14.0632 17.9132C14.0354 17.839 14.0162 17.7605 14.0067 17.6791L14 17.5625V14.0625C14 13.5102 14.4477 13.0625 15 13.0625Z"
  />
</svg>
